// extracted by mini-css-extract-plugin
export default {"link":"link_link__T2ijR","BRAND":"link_BRAND__HMYMx","brand":"link_BRAND__HMYMx"};